import axios from 'axios';

const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/worker-portal` });
const KEY = 'trendhomes_worker_portal';

export const session = {
  get: (token) => { try { const s = JSON.parse(localStorage.getItem(KEY) || 'null'); return s && s.t === token.slice(0, 8) ? s : null; } catch { return null; } },
  set: (token, data) => localStorage.setItem(KEY, JSON.stringify({ t: token.slice(0, 8), ...data })),
  clear: () => localStorage.removeItem(KEY),
};

// Separate client: never sends the CRM token, only the worker-portal session
export const portalApi = (sess) => {
  const h = { headers: { Authorization: `Bearer ${sess}` } };
  return {
    me: () => api.get('/me', h).then((r) => r.data),
    projects: (q) => api.get('/projects', { ...h, params: { q } }).then((r) => r.data),
    entries: () => api.get('/entries', h).then((r) => r.data),
    create: (b) => api.post('/entries', b, h).then((r) => r.data),
    update: (id, b) => api.put(`/entries/${id}`, b, h).then((r) => r.data),
    remove: (id) => api.delete(`/entries/${id}`, h).then((r) => r.data),
    logout: () => api.post('/logout', {}, h),
  };
};

export const portalLogin = (token, pin) => api.post('/login', { token, pin }).then((r) => r.data);

export const errText = (e, fb) => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : fb);

export const hoursOf = (start, end, brk) => {
  if (!start || !end) return null;
  const [a, b] = start.split(':').map(Number);
  const [c, d] = end.split(':').map(Number);
  const m = c * 60 + d - a * 60 - b - (Number(brk) || 0);
  return m > 0 ? Math.round((m / 60) * 100) / 100 : null;
};

export const todayWarsaw = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw' }).format(new Date());
